import { Component, OnInit, ViewChild } from '@angular/core';
import { LogsCardComponent } from 'src/app/logs-card/logs-card.component';
import {fromEvent} from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { MatTabGroup } from '@angular/material';

@Component({
  providers: [LogsCardComponent],
  selector: 'app-logs-dashboard',
  templateUrl: './logs-dashboard.component.html',
  styleUrls: ['./logs-dashboard.component.css']
})
export class LogsDashboardComponent implements OnInit {

  isfoodplan :boolean = false;
  isactivityplan :boolean = false;
  isfoodlogs :boolean = true;
  isweightlogs : boolean = false;
  isactivitylogs : boolean = false;
  ishealthlogs : boolean = false;
  isdashboard : boolean = true;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  constructor(private logCard: LogsCardComponent,
    private breakpointObserver: BreakpointObserver) {
    
    fromEvent(window, 'popstate')
    .subscribe((e) => {
     console.log(e, 'back button');
    });
    this.isfoodplan = false;
    this.isactivityplan = false;
    this.isfoodlogs = false;
    this.isweightlogs = false;
    this.isactivitylogs = false;
    this.ishealthlogs = false;
    this.isdashboard = true;
    console.log("in dashboard constructor");
  }

  ngOnInit() {
    console.log("in dashboard init");
  }

  changeTab(event) {
    console.log("in change tab");
    if (event.index == 0) {
      this.goToFoodLog();
    } else if (event.index == 1) {
      this.goToActivityLog();
    } else if (event.index == 2) {
      this.goToWeightLog();
    } else {
      this.goToHealthLog();
    }
  }

  goToFoodPlan() {
    this.isfoodplan = !this.isfoodplan;
    this.isdashboard = false;
   }

  goToActivityPlan() {
    this.isactivityplan = !this.isactivityplan;
    this.isdashboard = false;
   }
   
  goToFoodLog() {
    console.log("in go to food log");
    this.isfoodlogs = true;
    this.isweightlogs = false;
    this.isactivitylogs = false;
    this.ishealthlogs = false;
    this.isdashboard = false;
  }

  goToWeightLog() {
    this.isfoodlogs = false;
    this.isweightlogs = true;
    this.isactivitylogs = false;
    this.ishealthlogs = false;
    this.isdashboard = false;
  }
  
  goToActivityLog() {
    this.isfoodlogs = false;
    this.isweightlogs = false;
    this.isactivitylogs = true;
    this.ishealthlogs = false;
    this.isdashboard = false; 
  }

  goToHealthLog(){
    this.isfoodlogs = false;
    this.isweightlogs = false;
    this.isactivitylogs = false;
    this.ishealthlogs = true;
    this.isdashboard = false;
  }

  goToDashBoard($event){
    console.log("going to dashboard");
    if ($event == "saved")
    this.isfoodlogs = false;
    this.isweightlogs = false;
    this.isfoodplan = false;
    this.isactivityplan = false;
    this.isactivitylogs = false;
    this.ishealthlogs = false;
    this.isdashboard = true;
  }
}